import "../style/testing_tool.css";
import { NavLink } from "react-router-dom";

export default function TestingTools() {
  return (
    <>
      <section class="testing-tool-hero-guide-banner">
     
     
            <div class="hero-icon-container">
                <i class="fa-solid fa-screwdriver-wrench"></i> 
            </div>
            <h1>Testing Tools & Frameworks</h1>
            <p>Essential tools for every QA professional. Explore frameworks, automation libraries, performance tools, and reporting utilities to streamline your testing workflow.</p>
            <div class="stats-row">
                <div class="stat"><strong>15+</strong>Automation Frameworks</div>
                <div class="stat"><strong>20+</strong>Performance Tools</div>
                <div class="stat"><strong>50+</strong>Reporting Utilities</div>
            </div>
    
    
    </section>


      {/* NAV TABS */}
      <nav className="nav-tabs">
        <NavLink to="/software-testing">
          <i className="fa-solid fa-book-open"></i> Overview
        </NavLink>

        <NavLink to="/testing-types">
          <i className="fa-solid fa-box"></i> Types
        </NavLink>

        <NavLink to="/testing-pyramid">
          <i className="fa-solid fa-puzzle-piece"></i> Pyramid
        </NavLink>

        <NavLink to="/testing-methods" >
          <i className="fa-solid fa-code"></i> Methods
        </NavLink>

        <NavLink to="/testing-practices" >
          <i className="fa-solid fa-lightbulb"></i> Practices
        </NavLink>

        <NavLink to="/testing-tools" className="active">
          <i className="fa-solid fa-screwdriver-wrench"></i> Tools
        </NavLink>
      </nav>
    <main class="guide-content-container">
        
        <h2 class="section-heading">Testing Tools & Frameworks</h2>
        <p class="section-subheading">Popular tools for different testing needs and technologies</p>

        <h3 class="tool-section-title">JavaScript/TypeScript Testing</h3>
        <div class="tool-grid">
            
            <div class="tool-card">
                <h4><a href="https://jestjs.io/" target="_blank" rel="noreferrer">Jest <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Delightful JavaScript testing framework with built-in mocking and coverage</p>
                <div class="tag-group">
                    <span class="tag type-unit">Unit, Integration</span>
                    <span class="tag lang-js">JavaScript</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>Zero config</li>
                        <li>Snapshot testing</li>
                        <li>Code coverage</li>
                        <li>Mocking</li>
                    </ul>
                </div>
            </div>

            <div class="tool-card">
                <h4><a href="https://vitest.dev/" target="_blank" rel="noreferrer">Vitest <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Blazing fast unit test framework powered by Vite</p>
                <div class="tag-group">
                    <span class="tag type-unit">Unit, Integration</span>
                    <span class="tag lang-js">JavaScript</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>Vite-powered</li>
                        <li>Jest compatible</li>
                        <li>ESM first</li>
                        <li>TypeScript</li>
                    </ul>
                </div>
            </div>

            <div class="tool-card">
                <h4><a href="https://www.cypress.io/" target="_blank" rel="noreferrer">Cypress <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Fast, easy and reliable E2E testing for web applications</p>
                <div class="tag-group">
                    <span class="tag type-e2e">E2E, Integration</span>
                    <span class="tag lang-js">JavaScript</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>Time travel</li>
                        <li>Real-time reload</li>
                        <li>Network stubbing</li>
                        <li>Screenshots</li>
                    </ul>
                </div>
            </div>

            <div class="tool-card">
                <h4><a href="https://playwright.dev/" target="_blank" rel="noreferrer">Playwright <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Cross-browser E2E testing by Microsoft</p>
                <div class="tag-group">
                    <span class="tag type-e2e">E2E</span>
                    <span class="tag lang-js">JavaScript</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>Multi-browser</li>
                        <li>Auto-wait</li>
                        <li>Parallel testing</li>
                        <li>Trace viewer</li>
                    </ul>
                </div>
            </div>
            
            <div class="tool-card">
                <h4><a href="https://testing-library.com/" target="_blank" rel="noreferrer">Testing Library <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Simple and complete testing utilities for React and other frameworks</p>
                <div class="tag-group">
                    <span class="tag type-component">Component</span>
                    <span class="tag lang-js">JavaScript</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>User-centric</li>
                        <li>Framework agnostic</li>
                        <li>Accessible</li>
                        <li>Best practices</li>
                    </ul>
                </div>
            </div>
        </div>

        <h3 class="tool-section-title">Java Testing</h3>
        <div class="tool-grid">
            
            <div class="tool-card">
                <h4><a href="https://junit.org/" target="_blank" rel="noreferrer">JUnit <i class="fas fa-external-link-alt"></i></a></h4>
                <p>The most popular testing framework for Java</p>
                <div class="tag-group">
                    <span class="tag type-unit">Unit</span>
                    <span class="tag lang-js">Java</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>Annotations</li>
                        <li>Assertions</li>
                        <li>Test runners</li>
                        <li>Extensions</li>
                    </ul>
                </div>
            </div>

            <div class="tool-card">
                <h4><a href="https://site.mockito.org/" target="_blank" rel="noreferrer">Mockito <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Mocking framework for unit tests in Java</p>
                <div class="tag-group">
                    <span class="tag type-unit">Mocking</span>
                    <span class="tag lang-js">Java</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>Mock creation</li>
                        <li>Verification</li>
                        <li>Stubbing</li>
                        <li>Annotations</li>
                    </ul>
                </div>
            </div>

            <div class="tool-card">
                <h4><a href="https://www.selenium.dev/" target="_blank" rel="noreferrer">Selenium <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Browser automation framework</p>
                <div class="tag-group">
                    <span class="tag type-e2e">E2E</span>
                    <span class="tag lang-js">Multi-language</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>Cross-browser</li>
                        <li>Multiple languages</li>
                        <li>Grid support</li>
                        <li>Mature</li>
                    </ul>
                </div>
            </div>

            <div class="tool-card">
                <h4><a href="https://testng.org/" target="_blank" rel="noreferrer">TestNG <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Testing framework inspired by JUnit with more features</p>
                <div class="tag-group">
                    <span class="tag type-unit">Unit, Integration</span>
                    <span class="tag lang-js">Java</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>Data providers</li>
                        <li>Groups</li>
                        <li>Parallel execution</li>
                        <li>Flexible</li>
                    </ul>
                </div>
            </div>
</div>

    <h3 class="tool-section-title">Performance & Load Testing</h3>
        <div class="tool-grid">
            
            <div class="tool-card">
                <h4><a href="https://jmeter.apache.org/" target="_blank" rel="noreferrer">JMeter <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Open-source load testing tool</p>
                <div class="tag-group">
                    <span class="tag type-performance">Performance</span>
                    <span class="tag lang-java">Java</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>GUI & CLI</li>
                        <li>Protocols support</li>
                        <li>Distributed testing</li>
                        <li>Extensible</li>
                    </ul>
                </div>
            </div>

            <div class="tool-card">
                <h4><a href="https://k6.io/" target="_blank" rel="noreferrer">k6 <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Modern load testing tool built for developers</p>
                <div class="tag-group">
                    <span class="tag type-performance">Performance</span>
                    <span class="tag lang-js">JavaScript</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>JavaScript DSL</li>
                        <li>Cloud integration</li>
                        <li>Thresholds</li>
                        <li>Metrics</li>
                    </ul>
                </div>
            </div>

            <div class="tool-card">
                <h4><a href="https://gatling.io/" target="_blank" rel="noreferrer">Gatling <i class="fas fa-external-link-alt"></i></a></h4>
                <p>High-performance load testing tool</p>
                <div class="tag-group">
                    <span class="tag type-performance">Performance</span>
                    <span class="tag lang-scala">Scala</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>Scala DSL</li>
                        <li>Real-time reports</li>
                        <li>Scenarios</li>
                        <li>CI/CD ready</li>
                    </ul>
                </div>
            </div>

            <div class="tool-card">
                <h4><a href="https://developer.chrome.com/docs/lighthouse" target="_blank" rel="noreferrer">Lighthouse <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Automated tool for improving web page quality</p>
                <div class="tag-group">
                    <span class="tag type-performance">Performance, SEO</span>
                    <span class="tag lang-js">JavaScript</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>Performance audit</li>
                        <li>Accessibility</li>
                        <li>Best practices</li>
                        <li>PWA</li>
                    </ul>
                </div>
            </div>
        </div>
        
        <h3 class="tool-section-title">Security Testing</h3>
        <div class="tool-grid">
            
            <div class="tool-card">
                <h4><a href="https://www.zaproxy.org/" target="_blank" rel="noreferrer">OWASP ZAP <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Web application security scanner</p>
                <div class="tag-group">
                    <span class="tag type-security">Security</span>
                    <span class="tag lang-java">Java</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>Proxy</li>
                        <li>Scanner</li>
                        <li>API</li>
                        <li>Open source</li>
                    </ul>
                </div>
            </div>

            <div class="tool-card">
                <h4><a href="https://portswigger.net/burp" target="_blank" rel="noreferrer">Burp Suite <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Web vulnerability scanner</p>
                <div class="tag-group">
                    <span class="tag type-security">Security</span>
                    <span class="tag lang-java">Java</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>Proxy</li>
                        <li>Scanner</li>
                        <li>Intruder</li>
                        <li>Extensions</li>
                    </ul>
                </div>
            </div>

            <div class="tool-card">
                <h4><a href="https://www.sonarsource.com/products/sonarqube/" target="_blank" rel="noreferrer">SonarQube <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Code quality and security analysis platform</p>
                <div class="tag-group">
                    <span class="tag type-static">Static Analysis</span>
                    <span class="tag lang-multi">Multi-language</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>Multi-language</li>
                        <li>Security hotspots</li>
                        <li>Code smells</li>
                        <li>CI/CD</li>
                    </ul>
                </div>
            </div>
        </div>

        <h3 class="tool-section-title">API Testing</h3>
        <div class="tool-grid">
            
            <div class="tool-card">
                <h4><a href="https://www.postman.com/" target="_blank" rel="noreferrer">Postman <i class="fas fa-external-link-alt"></i></a></h4>
                <p>API development and testing platform</p>
                <div class="tag-group">
                    <span class="tag type-api">API</span>
                    <span class="tag type-gui">GUI</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>Collections</li>
                        <li>Automation</li>
                        <li>Collaboration</li>
                        <li>Monitoring</li>
                    </ul>
                </div>
            </div>

            <div class="tool-card">
                <h4><a href="https://rest-assured.io/" target="_blank" rel="noreferrer">REST Assured <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Java library for testing REST APIs</p>
                <div class="tag-group">
                    <span class="tag type-api">API</span>
                    <span class="tag lang-java">Java</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>DSL</li>
                        <li>JSON/XML support</li>
                        <li>Authentication</li>
                        <li>Response validation</li>
                    </ul>
                </div>
            </div>

            <div class="tool-card">
                <h4><a href="https://insomnia.rest/" target="_blank" rel="noreferrer">Insomnia <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Collaborative API development platform</p>
                <div class="tag-group">
                    <span class="tag type-api">API</span>
                    <span class="tag type-gui">GUI</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>GraphQL support</li>
                        <li>Environment variables</li>
                        <li>Code generation</li>
                        <li>Plugins</li>
                    </ul>
                </div>
            </div>

            <div class="tool-card">
                <h4><a href="https://pact.io/" target="_blank" rel="noreferrer">Pact <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Contract testing tool</p>
                <div class="tag-group">
                    <span class="tag type-contract">Contract</span>
                    <span class="tag lang-multi">Multi-language</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>Consumer-driven</li>
                        <li>Multiple languages</li>
                        <li>CI/CD</li>
                        <li>Broker</li>
                    </ul>
                </div>
            </div>
        </div>

   <h3 class="tool-section-title">Python Testing</h3>
        <div class="tool-grid">
            
            <div class="tool-card">
                <h4><a href="https://pytest.org/" target="_blank" rel="noreferrer">pytest <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Mature full-featured Python testing framework</p>
                <div class="tag-group">
                    <span class="tag type-unit-integration">Unit, Integration</span>
                    <span class="tag lang-python">Python</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>Fixtures</li>
                        <li>Parametrization</li>
                        <li>Plugins</li>
                        <li>Simple syntax</li>
                    </ul>
                </div>
            </div>

            <div class="tool-card">
                <h4><a href="https://docs.python.org/3/library/unittest.html" target="_blank" rel="noreferrer">unittest <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Built-in Python testing framework</p>
                <div class="tag-group">
                    <span class="tag type-unit">Unit</span>
                    <span class="tag lang-python">Python</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>Standard library</li>
                        <li>xUnit style</li>
                        <li>Test discovery</li>
                        <li>Mocking</li>
                    </ul>
                </div>
            </div>

            <div class="tool-card">
                <h4><a href="https://robotframework.org/" target="_blank" rel="noreferrer">Robot Framework <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Generic test automation framework for acceptance testing</p>
                <div class="tag-group">
                    <span class="tag type-acceptance">Acceptance, E2E</span>
                    <span class="tag lang-python">Python</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>Keyword-driven</li>
                        <li>Extensible</li>
                        <li>Libraries</li>
                        <li>Reports</li>
                    </ul>
                </div>
            </div>
        </div>

        <h3 class="tool-section-title">Mobile Testing</h3>
        <div class="tool-grid">
            
            <div class="tool-card">
                <h4><a href="https://appium.io/" target="_blank" rel="noreferrer">Appium <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Open-source test automation framework for mobile apps</p>
                <div class="tag-group">
                    <span class="tag type-e2e">E2E</span>
                    <span class="tag lang-multi">Multi-language</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>Cross-platform</li>
                        <li>Native & hybrid</li>
                        <li>WebDriver</li>
                        <li>Multi-language</li>
                    </ul>
                </div>
            </div>

            <div class="tool-card">
                <h4><a href="https://wix.github.io/Detox/" target="_blank" rel="noreferrer">Detox <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Gray box end-to-end testing framework for mobile apps</p>
                <div class="tag-group">
                    <span class="tag type-e2e">E2E</span>
                    <span class="tag lang-js">JavaScript</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>React Native</li>
                        <li>Synchronization</li>
                        <li>Fast</li>
                        <li>Reliable</li>
                    </ul>
                </div>
            </div>

            <div class="tool-card">
                <h4><a href="https://developer.android.com/training/testing/espresso" target="_blank" rel="noreferrer">Espresso <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Android UI testing framework</p>
                <div class="tag-group">
                    <span class="tag type-ui">UI</span>
                    <span class="tag lang-java-kotlin">Java/Kotlin</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>Android native</li>
                        <li>Auto-sync</li>
                        <li>Fast</li>
                        <li>Reliable</li>
                    </ul>
                </div>
            </div>

            <div class="tool-card">
                <h4><a href="https://developer.apple.com/documentation/xctest" target="_blank" rel="noreferrer">XCTest <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Apple's testing framework for iOS</p>
                <div class="tag-group">
                    <span class="tag type-unit-ui">Unit, UI</span>
                    <span class="tag lang-swift">Swift</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>iOS native</li>
                        <li>Xcode integration</li>
                        <li>Performance testing</li>
                        <li>UI testing</li>
                    </ul>
                </div>
            </div>
            </div>
        
     <h3 class="tool-section-title">Visual Testing</h3>
        <div class="tool-grid">
            
            <div class="tool-card">
                <h4><a href="https://percy.io/" target="_blank" rel="noreferrer">Percy <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Visual testing and review platform</p>
                <div class="tag-group">
                    <span class="tag type-visual">Visual</span>
                    <span class="tag lang-multi">Multi-language</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>Screenshot comparison</li>
                        <li>CI integration</li>
                        <li>Responsive testing</li>
                        <li>Snapshots</li>
                    </ul>
                </div>
            </div>

            <div class="tool-card">
                <h4><a href="https://www.chromatic.com/" target="_blank" rel="noreferrer">Chromatic <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Visual testing for Storybook</p>
                <div class="tag-group">
                    <span class="tag type-visual">Visual</span>
                    <span class="tag lang-js">JavaScript</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>UI component testing</li>
                        <li>Storybook integration</li>
                        <li>Collaboration</li>
                        <li>Cloud</li>
                    </ul>
                </div>
            </div>

            <div class="tool-card">
                <h4><a href="https://github.com/garris/BackstopJS" target="_blank" rel="noreferrer">BackstopJS <i class="fas fa-external-link-alt"></i></a></h4>
                <p>Visual regression testing tool</p>
                <div class="tag-group">
                    <span class="tag type-visual">Visual</span>
                    <span class="tag lang-js">JavaScript</span>
                </div>
                <div class="key-features">
                    <h5>Key Features:</h5>
                    <ul>
                        <li>Automated</li>
                        <li>Headless browser</li>
                        <li>Report generation</li>
                        <li>CLI</li>
                    </ul>
                </div>
            </div>
            
        </div>
        
        <h3 class="tool-section-title">Choosing the Right Tool</h3>
        <div class="info-panel tips-panel">
            <div class="tips-column">
                <h4>Consider These Factors:</h4>
                <ul>
                    <li><strong>Technology stack:</strong> Choose tools compatible with your language</li>
                    <li><strong>Team expertise:</strong> Consider learning curve and available skills</li>
                    <li><strong>Project requirements:</strong> Match tool capabilities to your needs</li>
                    <li><strong>Budget:</strong> Balance open-source vs commercial tools</li>
                    <li><strong>Integration:</strong> Ensure compatibility with your CI/CD pipeline</li>
                    <li><strong>Community support:</strong> Active community means better support</li>
                </ul>
            </div>
            <div class="tips-column">
                <h4>Tool Selection Tips:</h4>
                <ul>
                    <li>Start with popular, well-documented tools</li>
                    <li>Evaluate tools with proof-of-concept projects</li>
                    <li>Consider maintenance and long-term support</li>
                    <li>Don't over-engineer your testing stack</li>
                    <li>Prioritize tools that integrate well together</li>
                    <li>Review tool documentation and examples</li>
                </ul>
            </div>
        </div>

 {/* <div className="sharing-box">
          <h4>Share This Story, Choose Your Platform!</h4>
          <div className="fusion-social-networks">
    <NavLink to="https://facebook.com" target="_blank" rel="noreferrer" className="facebook">
      <i className="fab fa-facebook-f"></i>
    </NavLink>
    <NavLink to="https://twitter.com" target="_blank" rel="noreferrer" className="twitter">
      <i className="fab fa-twitter"></i>
    </NavLink>
    <NavLink to="https://www.linkedin.com/in/qa-coder-708418404/" target="_blank" rel="noreferrer" className="linkedin">
      <i className="fab fa-linkedin-in"></i>
    </NavLink>
    <NavLink to="https://wa.me/918299775823" target="_blank" rel="noreferrer" className="whatsapp">
      <i className="fab fa-whatsapp"></i>
    </NavLink>
    <NavLink to="mailto:qacoder0@gmail.com" className="email">
      <i className="fas fa-envelope"></i>
    </NavLink>

<NavLink to="https://www.instagram.com/qacoder0/?hl=en" target="_blank" rel="noreferrer" className="instagram">
  <i className="fab fa-instagram instagram-gradient"></i>
</NavLink>

<NavLink to="https://www.youtube.com/@QACoder" target="_blank" rel="noreferrer" className="youtube">
  <i className="fab fa-youtube"></i>
</NavLink>

<NavLink to="https://github.com/yourusername" target="_blank" rel="noreferrer" className="github">
  <i className="fab fa-github"></i>
</NavLink>

  </div>
        </div> */}

    </main>
    

     
    </>
  );
}
